/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
import React from 'react';

/** Header modal stack variant for MigrateToGatorProtectModal (`gatorProtectModalsVisibilityReducer`). */
export const GP_MODAL_VARIANT_MIGRATE_TO_GATOR_PROTECT = 'migrateToGatorProtect' as const;

/** Payload shape for `/api/v3/modals` entry `sitelock-free-accept`. */
export type GatorProtectMigratePortalModalEntry = {
  modal_id?: string;
  feature?: string;
  data?: { hosting_id?: number };
};

export type GradientButtonProps = {
  onClick?: () => void;
  testId?: string;
  label?: string | React.ReactNode;
  iconLeft?: React.ReactNode;
  iconRight?: React.ReactNode;
  variant?: string;
  width?: string;
  size?: string;
  gradientVariant?: string;
  disabled?: boolean;
  notFillSVG?: boolean;
};

export type ConsultedProduct = {
  id: number;
  prices?: {
    pricing?: {
      monthly?: string;
    };
  };
};

export type MigrateToGatorProtectModalLocale = {
  title: string;
  description: string;
  light: {
    title: string;
    list: string[];
    cta: string;
  };
  pro: {
    title: string
    list: string[],
    cta: (price: string) => string,
    terms?: string,
    termsCta?: string,
  },
};

export type GatorProtectLocale = {
  migrateToGatorProtectModal: MigrateToGatorProtectModalLocale;
  detectedThreadsModal?: {
    productTitle: string;
    productSubtitle: string;
    headline: string;
    bodyPrefix: string;
    threatsBold: ({ count }: { count: number }) => React.ReactNode;
    bodySuffixLine1: string;
    bodyLine2: string;
    primaryCta: string;
    shieldImageAlt: string;
  };
  acknowledgedModal?: {
    title: {
      trial: ({ days }: { days: number }) => string;
      pro: ({ plan }: { plan: string }) => string;
    };
    secondTitle: {
      trial: ({ days }: { days: number }) => string;
      pro: string;
    };
    description: {
      trial: React.ReactNode;
      pro: React.ReactNode;
    };
    perksTitle: string;
    perks: string[];
    cta: string;
    close: string;
    additionalInfo: {
      trial: string;
      pro: string;
    };
  };
  [key: string]: unknown;
};

export type MountCardProps ={
  tag: string;
  title: string;
  list: string[];
  cta: string;
  lightCard?: boolean;
  gradient?: boolean;
  terms?: string;
  termsCta?: string;
  onClick?: () => void;
}
